const data = [
	{
		COURSERA: `Completed course on “ Leadership and Emotional Intelligence” by Indian School of 
		Business`,
	},
	{
		COURSERA: `Completed course on “ Professional E-mail writing” by Georgia Institute of 
		Technology`,
	},
	{
		COURSERA: `Completed course on “ Self Awareness” by RICE University
		`,
	},
	{
		COURSERA: `Completed course on “ Machine Learning for All” by University of London`,
	},
	{
		COURSERA: `Completed course on “Learning How to Learn: Powerful mental tools to help you 
		master tough subjects” by UC San Diego`,
	},
	{
		COURSERA: `Completed course on “ Machine Learning Foundation: A Case Study Approach” by 
		University of Washington`,
	},
	{
		COURSERA: `Completed course on “ Introduction to Big Data” by UC San Diego`,
	},
	{
		COURSERA: `Completed course on “ Agile Meets Design Thinking” by University of Virginia`,
	},
];

export default data;
